/** The React hook (`useOnlineStatus`) lives in @tunasong/ui-lib: importing React here put it in every Lambda bundle */
export const isOnline = () => Boolean(typeof navigator !== 'undefined' && navigator.onLine)
